import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiSwitch = ({ palette, misc }: Pick<Tokens, 'palette' | 'misc'>) =>
  ({
    MuiSwitch: {
      defaultProps: {
        color: 'success',
      },

      styleOverrides: {
        root: {
          marginLeft: spacing(-1.5),
          width: spacing(9),
          height: spacing(6),
          padding: spacing(1.5),
        },
        switchBase: {
          backgroundColor: 'unset',
          ...misc.createHoverOrActiveState({
            backgroundColor: 'unset',
            outline: misc.borderStyle('dark.states.hover', 3),
            outlineOffset: spacing(-1.65),
          }),

          ...misc.createFocusVisibleState({
            backgroundColor: 'unset',
            outline: misc.borderStyle('info.main', 3),
            outlineOffset: spacing(-1.2),
          }),

          padding: spacing(1.5),
          '&.Mui-checked': {
            '&.MuiSwitch-switchBase': {
              transform: `translateX(${spacing(3)})`,
            },
            '&:hover': {
              backgroundColor: 'unset',
            },

            '& + .MuiSwitch-track': {
              opacity: 1,
            },
          },

          '&.Mui-checked:not(.Mui-disabled)': {
            '&.MuiSwitch-switchBase': {
              transform: `translateX(${spacing(3)})`,
            },

            '& + .MuiSwitch-track': {
              opacity: 1,
              borderColor: palette.success.main,
            },

            '& > .MuiSwitch-thumb': {
              borderColor: palette.success.main,
            },
          },

          '&.Mui-disabled': {
            '& + .MuiSwitch-track': {
              opacity: 1,
              backgroundColor: palette.action.disabled,
              borderColor: palette.components.switch.knobDisabled,
            },
            '& > .MuiSwitch-thumb': {
              opacity: 1,
              backgroundColor: palette.components.switch.knobDisabled,
              borderColor: palette.components.switch.knobDisabled,
            },
          },
        },
        thumb: {
          width: spacing(3),
          height: spacing(3),
          color: palette.static.light,
          backgroundColor: palette.static.light,
          border: misc.borderStyle('components.switch.border'),
          boxShadow: 'none',
        },
        track: {
          width: spacing(6),
          minWidth: spacing(6),
          height: spacing(3),
          opacity: 1,
          border: misc.borderStyle('components.switch.border'),
          borderRadius: spacing(5),
          backgroundColor: palette.components.switch.fill,
        },
      },
      variants: [],
    },
  }) satisfies ComponentCreation
